import { withInstall } from '../_util'
import { ElButton } from 'element-plus'
import { cloneDeep } from 'lodash-es'

const Button = cloneDeep(ElButton)
Button.name = 'OButton'
Button.__name = 'OButton'

import ButtonGroup from './ButtonGroup/ButtonGroup.vue'

export default withInstall<typeof Button, { ButtonGroup: typeof ButtonGroup }>(Button, {
  ButtonGroup
})
